<div class="weighted-input-item"  [ngClass]="{'has-delete': showDelete}">
  <div class="weighted-input-item__title">
    <label>
      {{question?.question_prompt}}
      @if (showToolTip) {
        <a
          class="popover-trigger popover-trigger--sm"
          tabindex="0"
          data-toggle="popover"
          data-trigger="focus"
          data-html="true"
          data-placement="bottom"
          data-content="<div class=&quot;popover__content&quot;>Tooltip content can go over here. Tooltip content can go over here.</div>"
          data-original-title=""
          title=""
          >
          <svg class="icon icon--sm">
            <use xlink:href="#help-Icon"></use>
          </svg>
        </a>
      }
    </label>
    <!-- <p class="form-control-helper">Description</p> -->
  </div>
  <div class="weighted-input-item__amount">
    <div class="form-group">
      <div class="input-wrap">
        @if (currency) {
          <div class="input-wrap-prepend">
            <div class="input-wrap-symbol">
              {{currency}}
            </div>
          </div>
        }
        <input
          type="text"
          [placeholder]="placeholder"
          class="form-control"
          [readOnly]="readonly"
          [disabled]="readonly"
          currencyMask
          [name]="uniqueControlName"
          [id]="uniqueId"
          [options]="maskOptions"
          [(ngModel)]="value"
          (ngModelChange)="onChange()"
          (blur)="onCommit()"
          class="form-control text-right" />
        </div>
      </div>
    </div>

    @if (showDelete) {
      <div class="weighted-input-item__delete">
        <a href="#" class="action-remove">
          <svg class="icon">
            <use xlink:href="#trash-bin"></use>
          </svg>
        </a>
      </div>
    }

    @if (itk?.itk_comment) {
      <div class="weighted-input-item__slot">
        @if (itk?.itk_comment) {
          <div class="itk">
            <div class="itk__items">
              <div class="itk__item">
                <div class="itk__item-icon">
                  <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm">
                </div>
                <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (itk?.itk_comment || '')"></div>
              </div>
            </div>
          </div>
        }
      </div>
    }

  </div>
